import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router";

import * as Api from "@/api";
import FabBar from "@/design/components/FabBar";
import MasterListVirtualized from "@/design/components/MasterListVirtualized";
import { disableSearch, enableSearch } from "@/store/reducers/ui";
import useSearch from "@/utils/hooks/useSearch";
import { toggleLoadingState } from "@/utils/utility";
import Valkyrie, { viPeople, viPlus } from "@sippy-platform/valkyrie";

import { useMediaQuery, useTheme } from "@mui/material";
import Button from "@mui/material/Button";

function GroupList() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const groupStore = useSelector((state) => state.domain.groups);
  const searchValue = useSelector((state) => state.ui.searchValue);
  const progressBar = useSelector((state) => state.ui.progressBar);

  // Search every time groupList or searchQuery changes
  const searchResults = useSearch(groupStore.list, searchValue, ["name", "exten"]);

  useEffect(() => {
    toggleLoadingState(true);
    Promise.resolve(Api.getGroups()).finally(toggleLoadingState);
  }, []);

  // Open first item or new if the viewport is large enough
  useEffect(() => {
    if (!id && matchesMdUp && groupStore.meta.lastFetched) {
      if (groupStore.list.length >= 1) {
        navigate(`${groupStore.list[0].id}`);
      } else {
        navigate("new");
      }
    }
  }, [id, matchesMdUp, navigate, groupStore.list, groupStore.meta.lastFetched]);

  useEffect(() => {
    dispatch(enableSearch());
  }, [dispatch]);
  useEffect(() => () => dispatch(disableSearch()), [dispatch]);

  return (
    <>
      <MasterListVirtualized
        fabBar
        title="Groups"
        aria-label="Group list"
        id="group-list"
        list={searchResults}
        listItemProps={{
          primary: (x) => x.name,
          secondary: (x) => x.exten,
          to: (x) => `../${x.id}`,
          selected: (x) => x.id === Number(id),
          icon: viPeople,
        }}
        hideContentLoader={groupStore.meta.count >= 1 && searchResults.length >= 1}
        contentLoaderProps={{
          count: groupStore.meta.count,
          loading: progressBar,
          noItems: "You don't have any groups yet",
          noResults: "No groups in your current query",
          fetching: "Getting your groups",
          icon: viPeople,
        }}
      />
      <FabBar>
        <Button variant="contained" component={NavLink} to="new" startIcon={<Valkyrie icon={viPlus} />}>
          Add
        </Button>
      </FabBar>
    </>
  );
}

export default GroupList;
